import React from 'react';
import { Link } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const PriveBusinessLeadership = () => {
  const events = [
    {
      title: 'Executive Leadership Forum',
      excerpt: 'Exclusive forum for C-suite executives and business leaders. Engage in strategic discussions on global business trends, leadership excellence, and innovation strategies.',
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800',
      date: 'Coming Soon',
      location: 'London',
      category: 'Leadership',
      slug: 'executive-leadership-forum'
    },
    {
      title: 'CEO Roundtable Series',
      excerpt: 'Intimate roundtable discussions with industry-leading CEOs. Share insights, challenges, and opportunities in a private, confidential setting with your peers.',
      image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800',
      date: 'Coming Soon',
      location: 'Dubai',
      category: 'Roundtable',
      slug: 'ceo-roundtable'
    },
    {
      title: 'Business Strategy Summit',
      excerpt: 'Annual summit bringing together business strategists, entrepreneurs, and investors. Learn cutting-edge strategies to scale your business and optimize operations.',
      image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800',
      date: 'Coming Soon',
      location: 'Cape Town',
      category: 'Summit',
      slug: 'business-strategy-summit'
    },
    {
      title: 'Private Equity Networking',
      excerpt: 'Connect with private equity firms, venture capitalists, and high-net-worth investors. Explore investment opportunities and partnership possibilities.',
      image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800',
      date: 'Coming Soon',
      location: 'London',
      category: 'Networking',
      slug: 'private-equity-networking'
    },
    {
      title: 'Innovation & Technology Forum',
      excerpt: 'Explore emerging technologies and digital transformation strategies. Featuring keynote speakers from leading tech companies and innovative startups.',
      image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800',
      date: 'Coming Soon',
      location: 'Dubai',
      category: 'Technology',
      slug: 'innovation-tech-forum'
    },
    {
      title: 'Executive Mastermind Retreat',
      excerpt: 'Multi-day immersive retreat for senior executives. Deep-dive workshops, peer coaching, and strategic planning in a luxurious, focused environment.',
      image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800',
      date: 'Coming Soon',
      location: 'Private Estate',
      category: 'Retreat',
      slug: 'executive-mastermind-retreat'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Privé Business Leadership Events</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Elite Business Leadership & Networking</p>
        
        <div className="blog-grid">
          {events.map((event, index) => (
            <div 
              key={index} 
              className={`blog-card ${index === 0 ? 'featured-post' : ''}`}
            >
              <img 
                src={event.image} 
                alt={event.title} 
                className="blog-image"
              />
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-tag">{event.category}</span>
                  <span><i className="far fa-calendar"></i> {event.date}</span>
                  <span><i className="fas fa-map-marker-alt"></i> {event.location}</span>
                </div>
                <h3 className="blog-title">{event.title}</h3>
                <p className="blog-excerpt">{event.excerpt}</p>
                <Link to={`/blog/${event.slug}`} className="blog-read-more">
                  View Details <i className="fas fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default PriveBusinessLeadership;
